:host {
  display: block;
}

@keyframes stickyAnimation {
  0% {
    top: -200px;
  }

  100% {
    top: 0;
  }
}

header {
  max-width: min(1600px, 100vw); // protect header if a div overflows in mobile
  margin: 0 auto;

  &.header-sticky {
    position: fixed;

    top: 0;
    width: 100%;

    @include layerIndex('header');

    @media (max-width: 1023px) {
      &.isMenuOpen {
        position: absolute;
        z-index: 1005; // move on top of the chat
      }
    }
  }

  &.small-header .header {
    height: 50px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);

    .header__logo {
      max-width: 105px;
    }
  }

  .header {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 36px;
    background: white;
    transition:
      height 0.3s,
      box-shadow 0.5s;

    @media (min-width: 768px) {
      padding-bottom: 0;
      height: 75px;
    }

    @media (min-width: 1280px) {
      padding-left: 50px;
      padding-right: 50px;
      height: 112px;
    }

    @media (min-width: 1600px) {
      padding-left: 100px;
      padding-right: 100px;
    }

    &__col {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &--left {
        flex: 1;
        margin-right: 20px;
      }
    }

    &__hamburger {
      position: absolute;
      top: 50px;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 35px;
      border-top: 1px solid var(--color-silver);

      @media (min-width: 768px) {
        position: static;
        border: none;
        margin-right: 20px;
      }
    }

    &__logo {
      width: 100%;
      max-width: 105px;
      transition: 0.3s;

      @media (min-width: 768px) {
        margin-right: 20px;
      }

      @media (min-width: 1400px) {
        width: 100%;
        max-width: 208px;
      }
    }

    &__nav-quick {
      display: none;
      margin-right: 20px;

      @media (min-width: 992px) {
        display: flex;
      }
    }

    &__search-form {
      position: absolute;
      bottom: 0;
      left: 50px;
      width: calc(100% - 50px);
      height: 35px;
      border-top: 1px solid var(--color-silver);
      background: var(--color-bleached-silk);

      @media (min-width: 768px) {
        position: static;
        border: none;
      }
    }
  }

  &.compact-header .header {
    @include breakpointMax('md') {
      padding-bottom: 0;
    }
  }
}

::slotted(lilu-logo) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

::slotted(lilu-link) {
  margin-right: 5px;
}

::slotted(lilu-unified-login-icon) {
  margin-right: 5px;
}

.navigation_container {
  display: none;

  &.isMenuOpen {
    overflow-x: clip;
    display: block;
    background-color: white;
    position: absolute;
    z-index: 50;
    width: 100%;
    max-width: 1600px;
    height: calc(var(--navigation-max-rows) * var(--navigation-item-height) + 30px);
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);

    @media (min-width: 992px) {
      max-height: calc(100vh - 112px);
      overflow: auto;

      &::-webkit-scrollbar {
        background-color: var(--color-livique-anthrazit);
        width: 7px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--color-livique-anthrazit);
        border: none;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-track {
        background-color: var(--color-bleached-silk);
      }

      // Firefox
      scrollbar-color: var(--color-livique-anthrazit) var(--color-bleached-silk);
      scrollbar-width: thin;
    }

    @media (max-width: 991px) {
      height: auto;
      position: absolute;
    }
  }
}

::slotted(lilu-language-selector) {
  margin-right: 10px;
}

::slotted(lilu-modal-link) {
  margin-right: 10px;
}

::slotted(span) {
  display: none;
  width: 1px;
  height: 40px;
  margin-left: 10px;
  margin-right: 15px;
  background: var(--color-silver);

  @media (min-width: 1280px) {
    display: block;
  }
}
